module.exports = __webpack_public_path__ + "img/natalia.630641ca.png";